import { create } from 'zustand';

interface IVerifyModalStore {
    visible: boolean;
    showVerifyModal: () => void;
    hideVerifyModal: () => void;
}

export const useVerifyModalStore = create<IVerifyModalStore>((set) => ({
    visible: false,
    showVerifyModal: () => set({ visible: true }),
    hideVerifyModal: () => set({ visible: false }),
}));
